<template>
  <v-select
    :items="items"
    :value="selectedValue"
    :rules="computedRules"
    :disabled="disabled"
    :readonly="readonly"
    v-bind="$attrs"
    @input="onInput"
  />
</template>

<script>
export default {
  name: 'IntPicker',
  props: {
    value: [Number, String],
    min: {
      type: Number,
      default: 1,
    },
    max: {
      type: Number,
      default: 100,
    },
    rules: Array,
    required: Boolean,
    disabled: Boolean,
    readonly: Boolean,
  },
  computed: {
    items() {
      if (this.max < this.min) {
        return [];
      }
      return Array.from({ length: this.max - this.min + 1 }, (_, index) => this.min + index);
    },
    selectedValue() {
      const normalized = this.normalize(this.value);
      return this.items.includes(normalized) ? normalized : null;
    },
    computedRules() {
      const rules = [
        v => {
          const normalized = this.normalize(v);
          return normalized === null || this.items.includes(normalized) || `値は${this.min}〜${this.max}の間で選択してください`;
        },
      ].concat(this.rules ?? []);

      if (this.required) {
        rules.unshift(this.$rules.required);
      }

      return rules;
    },
  },
  methods: {
    normalize(value) {
      if (value === null || value === undefined || value === '') {
        return null;
      }
      const num = typeof value === 'number' ? value : Number(value);
      if (Number.isNaN(num)) {
        return null;
      }
      return Math.floor(num);
    },
    onInput(value) {
      const normalized = this.normalize(value);
      const result = this.items.includes(normalized) ? normalized : null;
      this.$emit('input', result);
      this.$emit('change', result);
    },
  },
};
</script>

<style lang="scss" scoped></style>
